import { render, staticRenderFns } from "./MStoreDescriptionButton.vue?vue&type=template&id=1b283a2b&"
import script from "./MStoreDescriptionButton.vue?vue&type=script&lang=ts&"
export * from "./MStoreDescriptionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports